// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IdhO","footer":"styles_footer__3kd08"};